import initialstate from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {isApiResponseOk} from '../../util/utils';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function estimateReducer(state = initialstate.estimates, action) {
	switch (action.type) {
		case types.GET_ESTIMATES:
			if (action.response) {
				return action.response || state;
			}
		case types.DELETE_ESTIMATE:
			if (isApiResponseOk(action) || action.error.response.status === HttpStatusCodes.NotFound) {
				return {
					...state,
					data: state?.data?.filter((estimate) => estimate.id !== action.estimateId)
				};
			}
		default:
			return state;
	}
}
